// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c0e869c7","389":"7349727d","453":"580dd798","455":"47f33a68","857":"8443e809","977":"3276d311"}[chunkId] + ".chunk.js";
};